import React, { useRef, useEffect } from 'react';
import qs from 'qs';
import { CheckboxToggleRefinement } from './CheckboxToggleRefinement';
import { useToggleRefinement } from 'react-instantsearch';
import { updateSearchRefFromUrl } from '../utils';
import type { SearchState } from '../../collections/searchStateUrlStorageHelpers';

const RED_HOT_DEAL_ATTRIBUTE = 'all_calculated_product_tags';
const RED_HOT_DEAL_LABEL = 'Red Hot Deal';

interface CheckboxRedHotDealItemsProps {
  label: string;
  setIsRedHotDealItemsRefined: React.Dispatch<React.SetStateAction<boolean>>;
  nbRedHotDealItems: number;
}

const CheckboxRedHotDealItems = ({
  label,
  setIsRedHotDealItemsRefined,
  nbRedHotDealItems,
}: CheckboxRedHotDealItemsProps) => {
  const { value, refine } = useToggleRefinement({ attribute: RED_HOT_DEAL_ATTRIBUTE, on: RED_HOT_DEAL_LABEL });
  const isCurrentRefinement = !!value?.isRefined;
  const searchState = qs.parse(window.location.search.slice(1)) as SearchState;
  const searchRef = useRef(searchState);

  useEffect(() => {
    setIsRedHotDealItemsRefined(isCurrentRefinement);
  }, [isCurrentRefinement, setIsRedHotDealItemsRefined]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isCurrentRefinement = event.target.checked;
    refine({ isRefined: !isCurrentRefinement });
    updateSearchRefFromUrl(searchRef);
  };

  if (nbRedHotDealItems === 0) return null;

  return (
    <CheckboxToggleRefinement
      label={label}
      isChecked={isCurrentRefinement}
      onChange={onChange}
      count={nbRedHotDealItems}
      id="redHotDealItemsRefinement"
    />
  );
};

export default CheckboxRedHotDealItems;
